module.exports = __webpack_public_path__ + "img/streamline-icon-smart-home@450x450.354d7c0e.svg";